import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Zkontrolovat, jestli už uživatel souhlasil
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Malé zpoždění pro lepší UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slideUp">
      <div className="max-w-4xl mx-auto glass rounded-2xl p-4 sm:p-6 border border-dark-700 shadow-2xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <p className="text-white font-medium mb-1">Používáme cookies</p>
            <p className="text-dark-400 text-sm">
              Používáme cookies pro správné fungování aplikace a zlepšení uživatelské zkušenosti.{' '}
              <Link to="/cookies" className="text-primary-400 hover:text-primary-300">
                Více informací
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <button
              onClick={handleDecline}
              className="flex-1 sm:flex-none px-4 py-2 rounded-xl text-dark-400 hover:text-white hover:bg-dark-700 transition-colors text-sm font-medium"
            >
              Odmítnout
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 sm:flex-none px-6 py-2 rounded-xl gradient-bg text-white font-medium hover:opacity-90 transition-opacity text-sm"
            >
              Přijmout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
